import ConditionProperty from './ConditionProperty';
import ConditionVisibleControls from "./ConditionVisibleControls";

export default class EventTypeProperty extends ConditionProperty {
  static override readonly label: string = 'Event type';
  static override readonly formFields: ConditionVisibleControls  = { fieldName: false, fieldPath: false, fieldIndex: false };
  static override readonly type: number = 1;
  static readonly valueProps = [
    { type: 1, label: 'Structured' },
    { type: 2, label: 'Unstructured' },
    { type: 3, label: 'PageView' },
    { type: 4, label: 'LinkClick' },
    { type: 5, label: 'AdClick' },
    { type: 6, label: 'AdImpression' },
    { type: 7, label: 'Error' },
  ];

  buildDescription(): string {
    return `Event type ${this.getOperatorLabel()} [${this.getTypeLabel()}]`;
  }

  getTypeLabel(): string {
    const prop = EventTypeProperty.valueProps.find(prop => prop.type === this.condition.value);
    return prop ? prop.label : '';
  }
}
